<div class="document-detail-workflow-toggle-button-group-container">
  @if (control) {
    <mat-chip-listbox #listbox class="document-detail-workflow-toggle-button-group"
      [value]="selectedWorkflow"
      [formControl]="control" required>
      @if (workflowsWithFilter$ | async; as workflows) {
        @for (workflow of workflows; track workflow.code) {
          <mat-chip-option class="document-detail-workflow-toggle-button"
            (click)="onWorkflowChange(workflow)"
            [value]="workflow">
            {{ workflow.kuerzel }}
          </mat-chip-option>
        }
      }
    </mat-chip-listbox>
  }

</div>
@if (!selectedWorkflow) {
  <mat-error>Bitte wählen Sie einen Workflow aus!
  </mat-error>
}

